(() => {
  if (window.__volumeNudgeInit) return;
  window.__volumeNudgeInit = true;

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-volume-nudge-add]');
    if (!btn) return;
    e.preventDefault();

    const index = btn.dataset.index;
    const target = parseInt(btn.dataset.target, 10);
    const inDrawer = !!btn.closest('cart-drawer, cart-drawer-items');
    const input = document.getElementById(
      inDrawer ? `Drawer-quantity-${index}` : `Quantity-${index}`
    );

    btn.disabled = true;
    btn.classList.add('is-loading');

    if (input) {
      input.value = target;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    try {
      await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: btn.dataset.key, quantity: target }),
      });
    } finally {
      window.location.reload();
    }
  });
})();